import { render, staticRenderFns } from "./DetailTechnicalSupportKpi.vue?vue&type=template&id=72ca3908&"
import script from "./DetailTechnicalSupportKpi.vue?vue&type=script&lang=js&"
export * from "./DetailTechnicalSupportKpi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports